import { useState, useEffect, useCallback } from 'react';
import { Box, Breadcrumbs, Button, Container, Grid, Link, Typography } from '@mui/material';
import useSettings from '../../../hooks/useSettings';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { RootState, useDispatch, useSelector } from '../../../store';
import { getCustomerDetails, getCustomers } from '../../../slices/customers';
import CustomersListOfConnectedOrganizationsTable from './CustomersListOfConnectedOrganizationsTable';
import GenericBreadcrumb, {
  getBreadcrumbLabelFromUserDetails,
} from '../../../components/GenericBreadcrumb';

const CustomersListOfConnectedOrganizations = () => {
  const { settings } = useSettings();
  const dispatch = useDispatch();
  const { uuid } = useParams();

  const { customerDetails } = useSelector((state: RootState) => state.customers);

  useEffect(() => {
    if (!customerDetails?.user) {
      dispatch(getCustomerDetails({ uuid }));
    }
  }, [customerDetails]);

  return (
    <>
      <Helmet>
        <title>Dashboard: Customer organizations </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 4,
        }}
      >
        <Container maxWidth={settings.compact ? 'xl' : false}>
          <Grid container justifyContent="space-between" spacing={3}>
            <Grid item>
              <Typography color="textPrimary" variant="h5">
                Connected organizations
              </Typography>
              <GenericBreadcrumb
                replaceLastUUIDWith={getBreadcrumbLabelFromUserDetails(customerDetails)}
              />
            </Grid>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <CustomersListOfConnectedOrganizationsTable />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default CustomersListOfConnectedOrganizations;
